var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.4376 38.4585H40.5625V44.4776H53.4376V38.4585Z",
    stroke: "#111111",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0837 38.4585H68.2939C68.8454 38.4585 69.2923 38.0114 69.2923 37.4601V9.39542C69.2923 8.84408 68.8452 8.39703 68.2939 8.39703H25.7057C25.1541 8.39703 24.7073 8.84408 24.7073 9.39542V36.9585C24.7073 37.7869 25.3788 38.4585 26.2073 38.4585H38.0837Z",
    stroke: "#111111",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8184 47.6619H39.1814C38.8621 47.6619 38.6719 47.3059 38.8492 47.0406L40.5624 44.4776H53.4374L55.1505 47.0406C55.3279 47.3059 55.1377 47.6619 54.8184 47.6619Z",
    stroke: "#111111",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.487 18.603L54.7662 20.8816C52.4325 19.5388 49.772 18.8257 47.0003 18.8257C44.2286 18.8257 41.5665 19.539 39.2328 20.8799L37.5137 18.603C40.3458 16.9053 43.6027 16 47.0003 16C50.3979 16 53.6549 16.9053 56.487 18.603Z",
    fill: "#111111"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2947 22.8277L51.564 25.1192C50.165 24.4268 48.6109 24.0589 46.9997 24.0589C45.3883 24.0589 43.8341 24.4252 42.4353 25.1192L40.7031 22.8277C42.6103 21.7869 44.7609 21.2334 46.9998 21.2334C49.2369 21.2334 51.3892 21.7869 53.2947 22.8277Z",
    fill: "#111111"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0738 27.0943L48.2826 29.4632C47.8692 29.3503 47.4394 29.2938 46.9997 29.2938C46.5585 29.2938 46.1287 29.3503 45.7153 29.4632L43.9258 27.0927C44.8834 26.6829 45.9244 26.4683 46.9997 26.4683C48.0752 26.4683 49.1162 26.6829 50.0738 27.0943Z",
    fill: "#111111"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47 47.743V51.7711",
    stroke: "#111111",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0811 54.9044V52.689C49.0811 52.1821 48.6701 51.7711 48.1632 51.7711H45.837C45.3301 51.7711 44.9191 52.1821 44.9191 52.689V54.9044H43.0583C42.5514 54.9044 42.1404 55.3155 42.1404 55.8224V58.1487C42.1404 58.6556 42.5514 59.0667 43.0583 59.0667H50.9417C51.4486 59.0667 51.8596 58.6556 51.8596 58.1487V55.8224C51.8596 55.3155 51.4486 54.9044 50.9417 54.9044H49.0811Z",
    stroke: "#111111",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16 71.7813C16 69.0198 18.2386 66.7813 21 66.7813C23.7614 66.7813 26 69.0198 26 71.7813C26 74.5427 23.7614 76.7812 21 76.7812C18.2386 76.7812 16 74.5427 16 71.7813Z",
    stroke: "#111111",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.707 77.9141C27.6174 78.3186 28.3458 78.7975 28.8979 79.2826C29.7396 80.0221 30.2187 81.0905 30.2187 82.2109V83.6562C30.2187 84.5192 29.5192 85.2188 28.6562 85.2188H13.3437C12.4808 85.2188 11.7812 84.5192 11.7812 83.6562V82.2109C11.7812 81.0905 12.2604 80.0221 13.1021 79.2826C14.5272 78.0304 17.1264 76.7812 21 76.7812",
    stroke: "#111111",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.293 77.9141C14.3826 78.3186 13.6542 78.7975 13.1021 79.2826C12.2604 80.0221 11.7813 81.0905 11.7813 82.2109V83.6562C11.7813 84.5192 12.4808 85.2188 13.3438 85.2188H28.6563C29.5192 85.2188 30.2188 84.5192 30.2188 83.6562V82.2109C30.2188 81.0905 29.7396 80.0221 28.8979 79.2826C27.4728 78.0304 24.8736 76.7812 21 76.7812",
    stroke: "#111111",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M42 71.7813C42 69.0198 44.2386 66.7813 47 66.7813C49.7614 66.7813 52 69.0198 52 71.7813C52 74.5427 49.7614 76.7812 47 76.7812C44.2386 76.7812 42 74.5427 42 71.7813Z",
    stroke: "#111111",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M52.707 77.9141C53.6174 78.3186 54.3458 78.7975 54.8979 79.2826C55.7396 80.0221 56.2187 81.0905 56.2187 82.2109V83.6562C56.2187 84.5192 55.5192 85.2188 54.6562 85.2188H39.3437C38.4808 85.2188 37.7812 84.5192 37.7812 83.6562V82.2109C37.7812 81.0905 38.2604 80.0221 39.1021 79.2826C40.5272 78.0304 43.1264 76.7812 47 76.7812",
    stroke: "#111111",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M41.293 77.9141C40.3826 78.3186 39.6542 78.7975 39.1021 79.2826C38.2604 80.0221 37.7813 81.0905 37.7813 82.2109V83.6562C37.7813 84.5192 38.4808 85.2188 39.3438 85.2188H54.6563C55.5192 85.2188 56.2188 84.5192 56.2188 83.6562V82.2109C56.2188 81.0905 55.7396 80.0221 54.8979 79.2826C53.4728 78.0304 50.8736 76.7812 47 76.7812",
    stroke: "#111111",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M68 71.7813C68 69.0198 70.2386 66.7813 73 66.7813C75.7614 66.7813 78 69.0198 78 71.7813C78 74.5427 75.7614 76.7812 73 76.7812C70.2386 76.7812 68 74.5427 68 71.7813Z",
    stroke: "#111111",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M78.707 77.9141C79.6174 78.3186 80.3458 78.7975 80.8979 79.2826C81.7396 80.0221 82.2187 81.0905 82.2187 82.2109V83.6562C82.2187 84.5192 81.5192 85.2188 80.6562 85.2188H65.3437C64.4808 85.2188 63.7812 84.5192 63.7812 83.6562V82.2109C63.7812 81.0905 64.2604 80.0221 65.1021 79.2826C66.5272 78.0304 69.1264 76.7812 73 76.7812",
    stroke: "#111111",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M67.293 77.9141C66.3826 78.3186 65.6542 78.7975 65.1021 79.2826C64.2604 80.0221 63.7813 81.0905 63.7813 82.2109V83.6562C63.7813 84.5192 64.4808 85.2188 65.3438 85.2188H80.6563C81.5192 85.2188 82.2188 84.5192 82.2188 83.6562V82.2109C82.2188 81.0905 81.7396 80.0221 80.8979 79.2826C79.4728 78.0304 76.8736 76.7812 73 76.7812",
    stroke: "#111111",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8596 56.9851H70.9012C71.9152 56.9851 72.7372 57.8071 72.7372 58.821V63.1906",
    stroke: "#111111",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1402 56.9851H23.0986C22.0846 56.9851 21.2627 57.8071 21.2627 58.821V63.1906",
    stroke: "#111111",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M47 59.0667V62.9047",
    stroke: "#111111",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetwork);
export default __webpack_public_path__ + "static/media/network.5f369ba21b0a8268335ba8155f9ea97c.svg";
export { ForwardRef as ReactComponent };